<template>
  <div>
    <div class="hierarchy-name" v-for="(item,i) in list" :key="i" :class="{'is-select': item.selected}" @click="clickSelect(item,i)">
      {{item.label}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubPanel',
  components: {

  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    activePath: {
      type: Array,
      default: () => []
    },
    level: {
      type: String | Number,
      default: 0
    }
  },
  computed: {
    parentData() {
      if (this.level > 0) return this.activePath[this.level - 1]
      return null
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: function (val) {
        if (!val) return
        if (!val.length) return this.list = []

        const selected = !val.some(e => e.selected) && this.parentData?.selected
        const first = {
          parentId: val[0].parentId,
          label: '全部',
          parentPath: val[0].parentPath,
          selected,
          childOption: null
        }
        // 不拷贝
        this.list = [first, ...val]
      }
    },
  },
  data() {
    return {
      list: []
    }
  },
  methods: {
    clickSelect(val, i) {
      // 点击全部
      if (val.label === '全部') {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].selected && this.list[i].children) {
            for (let j = 0; j < this.list[i].children.length; j++) {
              this.list[i].children[j].selected = false
            }
          }
          this.list[i].selected = false
        }
        val.selected = true
        this.$emit('selectedAll', this.parentData)
      }
      else {
        // 点击子项
        this.list[0].selected = false
        this.$emit('selected', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
